import { z } from 'my-zod'
import { makeValidator } from '../../internal/validator'
import { billingCaseModel, billingCasePaymentMethodEnum } from './billing-case-model'

export const bulkUpdatePaymentMethodFragment = billingCaseModel
  .pick({
    paymentMethod: true,
    paymentMethodOther: true
  })
  .augment({
    shortIds: z.string().array()
  })

export type bulkUpdatePaymentMethodFragment = z.infer<typeof bulkUpdatePaymentMethodFragment>

export const validateBulkUpdatePaymentMethodFragment = makeValidator<bulkUpdatePaymentMethodFragment>((input, error) => {
  if (!input.paymentMethodOther && input.paymentMethod === billingCasePaymentMethodEnum.Enum.Other) {
    error('Payment method should be specified', ['paymentMethodOther'])
  }
})
